import type { Selector } from 'reselect';

import { FeatureFlag, Site } from '@swf/core/enums';
import type { RootState, SelectorCreator, Slicer } from '@swf/core/store';
import { select } from '@swf/core/store';

import type { defaultState } from './sports';

interface ThisType {
  isEligibleForPromotionalContent: Selector<RootState, boolean>;
}

const selectors = (_slice: Slicer<typeof defaultState>, createSelector: SelectorCreator) => ({
  isEligibleForPromotions(this: ThisType) {
    return createSelector(
      this.isEligibleForPromotionalContent,
      (rootState: RootState) => rootState.feature?.[FeatureFlag.ISPPromotions],
      (isEligibleForPromotionalContent, isPromotionsEnabled) => {
        if (!isPromotionsEnabled || !isEligibleForPromotionalContent) return false;

        return true;
      }
    );
  },
  isEligibleForPromotionalContent() {
    return createSelector(
      (rootState: RootState) => select.account.isAgeVerified(rootState),
      (rootState: RootState) => select.account.isVerifiedForMarketing(rootState),
      (rootState: RootState) => select.account.isVulnerablePlayer(rootState),
      (rootState: RootState) => select.account.isSelfExcluded(rootState),
      (rootState: RootState) => select.session.isAuthenticated(rootState),
      (rootState: RootState) => select.cms.getSiteId(rootState),
      (
        isAgeVerified,
        isVerifiedForMarketing,
        isVulnerablePlayer,
        isSelfExcluded,
        isAuthenticated,
        siteId
      ) => {
        if (siteId === Site.ES) {
          return (
            isAuthenticated &&
            isAgeVerified &&
            isVerifiedForMarketing &&
            !isVulnerablePlayer &&
            !isSelfExcluded
          );
        }

        return true;
      }
    );
  }
});

export default selectors;
